(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("UniDataManager", [], factory);
	else if(typeof exports === 'object')
		exports["UniDataManager"] = factory();
	else
		root["UniDataManager"] = factory();
})(self, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src)
});

;// CONCATENATED MODULE: ./src/utils.js
/**
 * 获取字符串长度
 * @param str
 * @returns {number}
 */
function getStringSize(str) {
  var n_str = str ? str : '';
  var size = 0;
  for (var i = 0; i < n_str.length; i++) {
    var code = n_str.charCodeAt(i);
    if (code < 0x007F) {
      size += 1;
    } else if (code < 0x07FF) {
      size += 2;
    } else if (code < 0xFFFF) {
      size += 3;
    } else {
      size += 4;
    }
  }
  return size;
}
;// CONCATENATED MODULE: ./src/memoryManager.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var MemoryManager = /*#__PURE__*/function () {
  function MemoryManager() {
    _classCallCheck(this, MemoryManager);
  }
  return _createClass(MemoryManager, [{
    key: "setMemoryData",
    value: function setMemoryData(key, value) {
      this.checkMemoryDataSize();
      this.memoryData[key] = value;
    }
  }, {
    key: "getMemoryData",
    value: function getMemoryData(key) {
      return this.memoryData[key];
    }
  }, {
    key: "removeMemoryData",
    value: function removeMemoryData(key) {
      delete this.memoryData[key];
    }
  }, {
    key: "clearMemoryData",
    value: function clearMemoryData() {
      this.memoryData = {};
    }
  }, {
    key: "getOnceMemoryData",
    value: function getOnceMemoryData(key) {
      var value = this.getMemoryData(key);
      this.removeMemoryData(key);
      return value;
    }
  }, {
    key: "getMemoryDataInfo",
    value: function getMemoryDataInfo() {
      return this.memoryData;
    }
  }, {
    key: "checkMemoryDataSize",
    value: function checkMemoryDataSize() {
      var currentCacheSizeBytes = getStringSize(JSON.stringify(this.memoryData));
      if (currentCacheSizeBytes > this._maxMemoryDataSizeBytes) {
        console.error('Memory data size exceeded. Consider removing unused data to free up memory.');
      }
    }
  }]);
}();
MemoryManager.prototype.memoryData = {};
MemoryManager.prototype._maxMemoryDataSizeBytes = 1024 * 1024 * 10; // 10MB
/* harmony default export */ const memoryManager = (MemoryManager);
;// CONCATENATED MODULE: ./src/indexedDBManager.js
function indexedDBManager_typeof(o) { "@babel/helpers - typeof"; return indexedDBManager_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, indexedDBManager_typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == indexedDBManager_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(indexedDBManager_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function indexedDBManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function indexedDBManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, indexedDBManager_toPropertyKey(descriptor.key), descriptor); } }
function indexedDBManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) indexedDBManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) indexedDBManager_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function indexedDBManager_toPropertyKey(t) { var i = indexedDBManager_toPrimitive(t, "string"); return "symbol" == indexedDBManager_typeof(i) ? i : i + ""; }
function indexedDBManager_toPrimitive(t, r) { if ("object" != indexedDBManager_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != indexedDBManager_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var IndexedDBManager = /*#__PURE__*/function () {
  function IndexedDBManager() {
    indexedDBManager_classCallCheck(this, IndexedDBManager);
  }
  return indexedDBManager_createClass(IndexedDBManager, [{
    key: "openDB",
    value: function openDB() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        var request = indexedDB.open(_this.dbName, _this.dbVersion);
        request.onerror = function (event) {
          console.error('Failed to open DB:', event.target.error);
          reject(event.target.error);
        };
        request.onsuccess = function (event) {
          _this.db = event.target.result;
          resolve(_this.db);
        };
        request.onupgradeneeded = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _this.db = event.target.result;
                  _context.next = 3;
                  return _this.createObjectStore('globalData');
                case 3:
                  event.target.transaction.oncomplete = function (event) {
                    resolve(_this.db);
                  };
                case 4:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      });
    }
  }, {
    key: "closeDB",
    value: function closeDB() {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        if (_this2.db) {
          _this2.db.close();
          _this2.db = null;
          resolve();
        } else {
          reject('DB is not open.');
        }
      });
    }
  }, {
    key: "clearDB",
    value: function clearDB() {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        if (_this3.db) {
          var objectStoreNames = _this3.db.objectStoreNames;
          for (var i = 0; i < objectStoreNames.length; i++) {
            _this3.db.deleteObjectStore(objectStoreNames[i]);
          }
          resolve();
        } else {
          reject('DB is not open.');
        }
      });
    }
  }, {
    key: "createObjectStore",
    value: function () {
      var _createObjectStore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(storeName) {
        var _this4 = this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.db) {
                _context3.next = 3;
                break;
              }
              _context3.next = 3;
              return this.openDB();
            case 3:
              return _context3.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve) {
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (_this4.db.objectStoreNames.contains(storeName)) {
                          resolve();
                        } else {
                          _this4.db.createObjectStore(storeName);
                          resolve();
                        }
                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }()));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function createObjectStore(_x2) {
        return _createObjectStore.apply(this, arguments);
      }
      return createObjectStore;
    }()
  }, {
    key: "deleteObjectStore",
    value: function () {
      var _deleteObjectStore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(storeName) {
        var _this5 = this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this.db) {
                _context5.next = 3;
                break;
              }
              _context5.next = 3;
              return this.openDB();
            case 3:
              return _context5.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(resolve) {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (_this5.db.objectStoreNames.contains(storeName)) {
                          _this5.db.deleteObjectStore(storeName);
                          resolve();
                        } else {
                          resolve();
                        }
                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x5) {
                  return _ref3.apply(this, arguments);
                };
              }()));
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function deleteObjectStore(_x4) {
        return _deleteObjectStore.apply(this, arguments);
      }
      return deleteObjectStore;
    }()
  }, {
    key: "setDBData",
    value: function () {
      var _setDBData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(storeName, key, value) {
        var _this6 = this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (this.db) {
                _context7.next = 6;
                break;
              }
              _context7.next = 3;
              return this.openDB();
            case 3:
              if (this.db.objectStoreNames.contains(storeName)) {
                _context7.next = 6;
                break;
              }
              _context7.next = 6;
              return this.createObjectStore(storeName);
            case 6:
              return _context7.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(resolve) {
                  var transaction, objectStore;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        transaction = _this6.db.transaction(storeName, 'readwrite');
                        objectStore = transaction.objectStore(storeName);
                        objectStore.put(value, key);
                        resolve();
                      case 4:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x9) {
                  return _ref4.apply(this, arguments);
                };
              }()));
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function setDBData(_x6, _x7, _x8) {
        return _setDBData.apply(this, arguments);
      }
      return setDBData;
    }()
  }, {
    key: "getDBData",
    value: function () {
      var _getDBData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(storeName, key) {
        var _this7 = this;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (this.db) {
                _context9.next = 6;
                break;
              }
              _context9.next = 3;
              return this.openDB();
            case 3:
              if (this.db.objectStoreNames.contains(storeName)) {
                _context9.next = 6;
                break;
              }
              _context9.next = 6;
              return this.createObjectStore(storeName);
            case 6:
              return _context9.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(resolve, reject) {
                  var transaction, objectStore, request;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        transaction = _this7.db.transaction(storeName, 'readonly');
                        objectStore = transaction.objectStore(storeName);
                        request = objectStore.get(key);
                        request.onerror = function (event) {
                          reject(event.target.error);
                        };
                        request.onsuccess = function (event) {
                          resolve(event.target.result);
                        };
                      case 5:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x12, _x13) {
                  return _ref5.apply(this, arguments);
                };
              }()));
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getDBData(_x10, _x11) {
        return _getDBData.apply(this, arguments);
      }
      return getDBData;
    }()
  }, {
    key: "removeDBData",
    value: function () {
      var _removeDBData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(storeName, key) {
        var _this8 = this;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (this.db) {
                _context11.next = 6;
                break;
              }
              _context11.next = 3;
              return this.openDB();
            case 3:
              if (this.db.objectStoreNames.contains(storeName)) {
                _context11.next = 6;
                break;
              }
              _context11.next = 6;
              return this.createObjectStore(storeName);
            case 6:
              return _context11.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(resolve) {
                  var transaction, objectStore;
                  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        transaction = _this8.db.transaction(storeName, 'readwrite');
                        objectStore = transaction.objectStore(storeName);
                        objectStore["delete"](key);
                        resolve();
                      case 4:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee10);
                }));
                return function (_x16) {
                  return _ref6.apply(this, arguments);
                };
              }()));
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function removeDBData(_x14, _x15) {
        return _removeDBData.apply(this, arguments);
      }
      return removeDBData;
    }()
  }, {
    key: "clearDBData",
    value: function () {
      var _clearDBData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(storeName) {
        var _this9 = this;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(resolve, reject) {
                  var transaction, objectStore;
                  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                    while (1) switch (_context12.prev = _context12.next) {
                      case 0:
                        if (_this9.db) {
                          transaction = _this9.db.transaction(storeName, 'readwrite');
                          objectStore = transaction.objectStore(storeName);
                          objectStore.clear();
                          resolve();
                        } else {
                          reject('DB is not open.');
                        }
                      case 1:
                      case "end":
                        return _context12.stop();
                    }
                  }, _callee12);
                }));
                return function (_x18, _x19) {
                  return _ref7.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      function clearDBData(_x17) {
        return _clearDBData.apply(this, arguments);
      }
      return clearDBData;
    }()
  }, {
    key: "getDBDataInfo",
    value: function () {
      var _getDBDataInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(storeName) {
        var _this10 = this;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(resolve, reject) {
                  var transaction, objectStore, request;
                  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                    while (1) switch (_context14.prev = _context14.next) {
                      case 0:
                        if (_this10.db) {
                          transaction = _this10.db.transaction(storeName, 'readonly');
                          objectStore = transaction.objectStore(storeName);
                          request = objectStore.getAll();
                          request.onerror = function (event) {
                            reject(event.target.error);
                          };
                          request.onsuccess = function (event) {
                            resolve(event.target.result);
                          };
                        } else {
                          reject('DB is not open.');
                        }
                      case 1:
                      case "end":
                        return _context14.stop();
                    }
                  }, _callee14);
                }));
                return function (_x21, _x22) {
                  return _ref8.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      function getDBDataInfo(_x20) {
        return _getDBDataInfo.apply(this, arguments);
      }
      return getDBDataInfo;
    }()
  }]);
}();
IndexedDBManager.prototype.dbName = 'uni-data-manager';
IndexedDBManager.prototype.dbVersion = 1;
IndexedDBManager.prototype.db = null;
/* harmony default export */ const indexedDBManager = (IndexedDBManager);
;// CONCATENATED MODULE: ./src/localStorageManager.js
function localStorageManager_typeof(o) { "@babel/helpers - typeof"; return localStorageManager_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, localStorageManager_typeof(o); }
function localStorageManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function localStorageManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, localStorageManager_toPropertyKey(descriptor.key), descriptor); } }
function localStorageManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) localStorageManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) localStorageManager_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function localStorageManager_toPropertyKey(t) { var i = localStorageManager_toPrimitive(t, "string"); return "symbol" == localStorageManager_typeof(i) ? i : i + ""; }
function localStorageManager_toPrimitive(t, r) { if ("object" != localStorageManager_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != localStorageManager_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LocalStorageManager = /*#__PURE__*/function () {
  function LocalStorageManager() {
    localStorageManager_classCallCheck(this, LocalStorageManager);
  }
  return localStorageManager_createClass(LocalStorageManager, [{
    key: "setLocalStorage",
    value: function setLocalStorage(key, value) {
      localStorage.setItem(key, value);
    }
  }, {
    key: "getLocalStorage",
    value: function getLocalStorage(key) {
      return localStorage.getItem(key);
    }
  }, {
    key: "removeLocalStorage",
    value: function removeLocalStorage(key) {
      localStorage.removeItem(key);
    }
  }, {
    key: "clearLocalStorage",
    value: function clearLocalStorage() {
      localStorage.clear();
    }
  }, {
    key: "getLocalStorageInfo",
    value: function getLocalStorageInfo() {
      return localStorage;
    }
  }]);
}();
/* harmony default export */ const localStorageManager = (LocalStorageManager);
;// CONCATENATED MODULE: ./src/mixinClass.js
function mixinClass_typeof(o) { "@babel/helpers - typeof"; return mixinClass_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, mixinClass_typeof(o); }
function mixinClass_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, mixinClass_toPropertyKey(descriptor.key), descriptor); } }
function mixinClass_createClass(Constructor, protoProps, staticProps) { if (protoProps) mixinClass_defineProperties(Constructor.prototype, protoProps); if (staticProps) mixinClass_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function mixinClass_toPropertyKey(t) { var i = mixinClass_toPrimitive(t, "string"); return "symbol" == mixinClass_typeof(i) ? i : i + ""; }
function mixinClass_toPrimitive(t, r) { if ("object" != mixinClass_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != mixinClass_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function mixinClass_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (mixinClass_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var mixinClass = function mixinClass(base) {
  for (var _len = arguments.length, mixins = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    mixins[_key - 1] = arguments[_key];
  }
  var baseWithMixins = /*#__PURE__*/function (_base) {
    function baseWithMixins() {
      var _this;
      mixinClass_classCallCheck(this, baseWithMixins);
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      _this = _callSuper(this, baseWithMixins, [].concat(args));
      mixins.forEach(function (mixin) {
        if (mixin.prototype.initializer) {
          mixin.prototype.initializer.call(_this);
        }
      });
      return _this;
    }
    _inherits(baseWithMixins, _base);
    return mixinClass_createClass(baseWithMixins);
  }(base);
  for (var _i = 0, _mixins = mixins; _i < _mixins.length; _i++) {
    var mixin = _mixins[_i];
    var prototype = mixin.prototype;
    while (prototype) {
      var mixinPrototype = Object.getOwnPropertyDescriptors(prototype);
      Object.defineProperties(baseWithMixins.prototype, mixinPrototype);
      prototype = Object.getPrototypeOf(prototype);
    }
  }
  return baseWithMixins;
};
/* harmony default export */ const src_mixinClass = (mixinClass);
;// CONCATENATED MODULE: ./src/cacheManager.js
function cacheManager_typeof(o) { "@babel/helpers - typeof"; return cacheManager_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, cacheManager_typeof(o); }
function cacheManager_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ cacheManager_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == cacheManager_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(cacheManager_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = cacheManager_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function cacheManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function cacheManager_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { cacheManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { cacheManager_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function cacheManager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function cacheManager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, cacheManager_toPropertyKey(descriptor.key), descriptor); } }
function cacheManager_createClass(Constructor, protoProps, staticProps) { if (protoProps) cacheManager_defineProperties(Constructor.prototype, protoProps); if (staticProps) cacheManager_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function cacheManager_toPropertyKey(t) { var i = cacheManager_toPrimitive(t, "string"); return "symbol" == cacheManager_typeof(i) ? i : i + ""; }
function cacheManager_toPrimitive(t, r) { if ("object" != cacheManager_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != cacheManager_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function cacheManager_callSuper(t, o, e) { return o = cacheManager_getPrototypeOf(o), cacheManager_possibleConstructorReturn(t, cacheManager_isNativeReflectConstruct() ? Reflect.construct(o, e || [], cacheManager_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function cacheManager_possibleConstructorReturn(self, call) { if (call && (cacheManager_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return cacheManager_assertThisInitialized(self); }
function cacheManager_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function cacheManager_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (cacheManager_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function cacheManager_getPrototypeOf(o) { cacheManager_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return cacheManager_getPrototypeOf(o); }
function cacheManager_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) cacheManager_setPrototypeOf(subClass, superClass); }
function cacheManager_setPrototypeOf(o, p) { cacheManager_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return cacheManager_setPrototypeOf(o, p); }




var CacheManager = /*#__PURE__*/function (_mixinClass) {
  function CacheManager() {
    cacheManager_classCallCheck(this, CacheManager);
    return cacheManager_callSuper(this, CacheManager);
  }
  cacheManager_inherits(CacheManager, _mixinClass);
  return cacheManager_createClass(CacheManager, [{
    key: "setCacheData",
    value: function () {
      var _setCacheData = cacheManager_asyncToGenerator( /*#__PURE__*/cacheManager_regeneratorRuntime().mark(function _callee(key, value) {
        var currentDataSizeBytes, _this$checkCacheDataS, isUpgrade;
        return cacheManager_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              currentDataSizeBytes = getStringSize(JSON.stringify(value));
              if (!(typeof indexedDB !== 'undefined' && currentDataSizeBytes > this._upgradeDataSizeBytes)) {
                _context.next = 7;
                break;
              }
              _context.next = 5;
              return this.setDBData('globalData', key, _objectSpread(_objectSpread({}, value), {}, {
                _isUpgrade: true
              }));
            case 5:
              _context.next = 15;
              break;
            case 7:
              _this$checkCacheDataS = this.checkCacheDataSize(), isUpgrade = _this$checkCacheDataS.isUpgrade;
              if (!(typeof indexedDB !== 'undefined' && isUpgrade)) {
                _context.next = 14;
                break;
              }
              _context.next = 11;
              return this.setDBData('globalData', key, _objectSpread(_objectSpread({}, value), {}, {
                _isUpgrade: true
              }));
            case 11:
              console.error('Cache data size exceeded. Data is automatically upgraded to the indexedDB.');
              _context.next = 15;
              break;
            case 14:
              if (typeof uni !== 'undefined' && typeof uni.setStorageSync === 'function') {
                uni.setStorageSync(key, JSON.stringify(value));
              } else {
                this.setLocalStorage(key, JSON.stringify(value));
              }
            case 15:
              _context.next = 20;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](0);
              console.error('Failed to set cache data:', _context.t0);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 17]]);
      }));
      function setCacheData(_x, _x2) {
        return _setCacheData.apply(this, arguments);
      }
      return setCacheData;
    }()
  }, {
    key: "getCacheData",
    value: function () {
      var _getCacheData = cacheManager_asyncToGenerator( /*#__PURE__*/cacheManager_regeneratorRuntime().mark(function _callee2(key) {
        var value, dbData;
        return cacheManager_regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              if (!(typeof uni !== 'undefined' && typeof uni.getStorageSync === 'function')) {
                _context2.next = 5;
                break;
              }
              value = uni.getStorageSync(key);
              if (!value) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", JSON.parse(value));
            case 5:
              if (!(typeof indexedDB !== 'undefined')) {
                _context2.next = 12;
                break;
              }
              _context2.next = 8;
              return this.getDBData('globalData', key);
            case 8:
              dbData = _context2.sent;
              if (!(dbData && dbData._isUpgrade)) {
                _context2.next = 12;
                break;
              }
              delete dbData._isUpgrade;
              return _context2.abrupt("return", dbData);
            case 12:
              if (!(typeof localStorage !== 'undefined')) {
                _context2.next = 14;
                break;
              }
              return _context2.abrupt("return", JSON.parse(this.getLocalStorage(key)) || {});
            case 14:
              return _context2.abrupt("return", {});
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](0);
              console.error('Failed to get cache data:', _context2.t0);
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 17]]);
      }));
      function getCacheData(_x3) {
        return _getCacheData.apply(this, arguments);
      }
      return getCacheData;
    }()
  }, {
    key: "getOnceCacheData",
    value: function getOnceCacheData(key) {
      var value = this.getCacheData(key);
      return this.removeCacheData(key).then(function () {
        return value;
      });
    }
  }, {
    key: "removeCacheData",
    value: function () {
      var _removeCacheData = cacheManager_asyncToGenerator( /*#__PURE__*/cacheManager_regeneratorRuntime().mark(function _callee3(key) {
        var value, dbData;
        return cacheManager_regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              value = null;
              if (typeof uni !== 'undefined' && typeof uni.getStorageSync === 'function') {
                value = uni.getStorageSync(key);
                if (value) {
                  uni.removeStorageSync(key);
                }
              }
              if (value) {
                _context3.next = 17;
                break;
              }
              if (!(typeof indexedDB !== 'undefined')) {
                _context3.next = 16;
                break;
              }
              _context3.next = 7;
              return this.getDBData('globalData', key);
            case 7:
              dbData = _context3.sent;
              if (!(dbData && dbData._isUpgrade)) {
                _context3.next = 13;
                break;
              }
              _context3.next = 11;
              return this.removeDBData('globalData', key);
            case 11:
              _context3.next = 14;
              break;
            case 13:
              this.removeLocalStorage(key);
            case 14:
              _context3.next = 17;
              break;
            case 16:
              this.removeLocalStorage(key);
            case 17:
              _context3.next = 22;
              break;
            case 19:
              _context3.prev = 19;
              _context3.t0 = _context3["catch"](0);
              console.error('Failed to remove cache data:', _context3.t0);
            case 22:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 19]]);
      }));
      function removeCacheData(_x4) {
        return _removeCacheData.apply(this, arguments);
      }
      return removeCacheData;
    }()
  }, {
    key: "clearCacheData",
    value: function clearCacheData() {
      try {
        if (typeof uni !== 'undefined' && typeof uni.clearStorageSync === 'function') {
          uni.clearStorageSync();
        } else {
          this.clearLocalStorage();
        }
      } catch (e) {
        console.error('Failed to clear cache data:', e);
      }
    }
  }, {
    key: "getCacheDataInfo",
    value: function getCacheDataInfo() {
      var _this = this;
      try {
        if (typeof uni !== 'undefined' && typeof uni.getStorageInfoSync === 'function') {
          var keys = uni.getStorageInfoSync().keys;
          var cacheData = {};
          keys.forEach(function (key) {
            cacheData[key] = _this.getCacheData(key);
          });
          return cacheData;
        } else {
          return this.getLocalStorageInfo();
        }
      } catch (e) {
        console.error('Failed to get cache data info:', e);
      }
    }
  }, {
    key: "checkCacheDataSize",
    value: function checkCacheDataSize() {
      try {
        if (typeof uni !== 'undefined' && typeof uni.getStorageInfoSync === 'function') {
          var isApp = uni.getSystemInfoSync().uniPlatform === 'app';
          var keys = uni.getStorageInfoSync().keys;
          var currentCacheSizeBytes = keys.reduce(function (total, key) {
            return total + getStringSize(JSON.stringify(uni.getStorageSync(key)));
          }, 0);
          if (isApp) {
            return {
              isUpgrade: false
            };
          } else if (currentCacheSizeBytes > this._maxCacheDataSizeBytes) {
            console.error('Cache data size exceeded. Consider removing unused data to free up memory.');
            return {
              isUpgrade: true
            };
          }
        }
        var currentLocalStorageSizeBytes = getStringSize(JSON.stringify(this.getLocalStorageInfo()));
        if (currentLocalStorageSizeBytes > this._maxCacheDataSizeBytes) {
          console.error('Cache data size exceeded. Consider removing unused data to free up memory.');
          return {
            isUpgrade: true
          };
        }
        return {
          isUpgrade: false
        };
      } catch (e) {
        console.error('Failed to check cache data size:', e);
      }
    }
  }]);
}(src_mixinClass(indexedDBManager, localStorageManager));
CacheManager.prototype._maxCacheDataSizeBytes = 1024 * 1024 * 5; // 5MB
CacheManager.prototype._upgradeDataSizeBytes = 1024 * 1024; // 1MB
/* harmony default export */ const cacheManager = (CacheManager);
;// CONCATENATED MODULE: ./src/index.js
function src_typeof(o) { "@babel/helpers - typeof"; return src_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, src_typeof(o); }
function src_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ src_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == src_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(src_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function src_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function src_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { src_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { src_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function src_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function src_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, src_toPropertyKey(descriptor.key), descriptor); } }
function src_createClass(Constructor, protoProps, staticProps) { if (protoProps) src_defineProperties(Constructor.prototype, protoProps); if (staticProps) src_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function src_toPropertyKey(t) { var i = src_toPrimitive(t, "string"); return "symbol" == src_typeof(i) ? i : i + ""; }
function src_toPrimitive(t, r) { if ("object" != src_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != src_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function src_callSuper(t, o, e) { return o = src_getPrototypeOf(o), src_possibleConstructorReturn(t, src_isNativeReflectConstruct() ? Reflect.construct(o, e || [], src_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function src_possibleConstructorReturn(self, call) { if (call && (src_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return src_assertThisInitialized(self); }
function src_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function src_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (src_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = src_getPrototypeOf(object); if (object === null) break; } return object; }
function src_getPrototypeOf(o) { src_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return src_getPrototypeOf(o); }
function src_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) src_setPrototypeOf(subClass, superClass); }
function src_setPrototypeOf(o, p) { src_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return src_setPrototypeOf(o, p); }



var DataManager = /*#__PURE__*/function (_mixinClass) {
  function DataManager() {
    src_classCallCheck(this, DataManager);
    return src_callSuper(this, DataManager);
  }
  src_inherits(DataManager, _mixinClass);
  return src_createClass(DataManager, [{
    key: "openDB",
    value: function () {
      var _openDB = src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee() {
        return src_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof indexedDB !== 'undefined')) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", _get(src_getPrototypeOf(DataManager.prototype), "openDB", this).call(this));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function openDB() {
        return _openDB.apply(this, arguments);
      }
      return openDB;
    }()
  }, {
    key: "closeDB",
    value: function () {
      var _closeDB = src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee2() {
        return src_regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(typeof indexedDB !== 'undefined')) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return", _get(src_getPrototypeOf(DataManager.prototype), "closeDB", this).call(this));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function closeDB() {
        return _closeDB.apply(this, arguments);
      }
      return closeDB;
    }()
  }, {
    key: "clearDB",
    value: function () {
      var _clearDB = src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee3() {
        return src_regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(typeof indexedDB !== 'undefined')) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return", _get(src_getPrototypeOf(DataManager.prototype), "clearDB", this).call(this));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function clearDB() {
        return _clearDB.apply(this, arguments);
      }
      return clearDB;
    }()
  }, {
    key: "createObjectStore",
    value: function () {
      var _createObjectStore = src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee4(storeName) {
        return src_regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(typeof indexedDB !== 'undefined')) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return", _get(src_getPrototypeOf(DataManager.prototype), "createObjectStore", this).call(this, storeName));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function createObjectStore(_x) {
        return _createObjectStore.apply(this, arguments);
      }
      return createObjectStore;
    }()
  }, {
    key: "deleteObjectStore",
    value: function () {
      var _deleteObjectStore = src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee5(storeName) {
        return src_regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(typeof indexedDB !== 'undefined')) {
                _context5.next = 4;
                break;
              }
              return _context5.abrupt("return", _get(src_getPrototypeOf(DataManager.prototype), "deleteObjectStore", this).call(this, storeName));
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function deleteObjectStore(_x2) {
        return _deleteObjectStore.apply(this, arguments);
      }
      return deleteObjectStore;
    }()
  }, {
    key: "setDBData",
    value: function setDBData(storeName, key, value) {
      if (typeof indexedDB !== 'undefined') {
        return _get(src_getPrototypeOf(DataManager.prototype), "setDBData", this).call(this, storeName, key, value);
      } else {
        return this.setCacheData(key, value);
      }
    }
  }, {
    key: "getDBData",
    value: function getDBData(storeName, key) {
      if (typeof indexedDB !== 'undefined') {
        return _get(src_getPrototypeOf(DataManager.prototype), "getDBData", this).call(this, storeName, key);
      } else {
        return this.getCacheData(key);
      }
    }
  }, {
    key: "removeDBData",
    value: function () {
      var _removeDBData = src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee6(storeName, key) {
        return src_regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(typeof indexedDB !== 'undefined')) {
                _context6.next = 4;
                break;
              }
              return _context6.abrupt("return", _get(src_getPrototypeOf(DataManager.prototype), "removeDBData", this).call(this, storeName, key));
            case 4:
              return _context6.abrupt("return", this.removeCacheData(key));
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function removeDBData(_x3, _x4) {
        return _removeDBData.apply(this, arguments);
      }
      return removeDBData;
    }()
  }, {
    key: "clearDBData",
    value: function () {
      var _clearDBData = src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee7(storeName) {
        return src_regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(typeof indexedDB !== 'undefined')) {
                _context7.next = 4;
                break;
              }
              return _context7.abrupt("return", _get(src_getPrototypeOf(DataManager.prototype), "clearDBData", this).call(this, storeName));
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function clearDBData(_x5) {
        return _clearDBData.apply(this, arguments);
      }
      return clearDBData;
    }()
  }, {
    key: "getDBDataInfo",
    value: function () {
      var _getDBDataInfo = src_asyncToGenerator( /*#__PURE__*/src_regeneratorRuntime().mark(function _callee8(storeName) {
        return src_regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(typeof indexedDB !== 'undefined')) {
                _context8.next = 4;
                break;
              }
              return _context8.abrupt("return", _get(src_getPrototypeOf(DataManager.prototype), "getDBDataInfo", this).call(this, storeName));
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getDBDataInfo(_x6) {
        return _getDBDataInfo.apply(this, arguments);
      }
      return getDBDataInfo;
    }()
  }]);
}(src_mixinClass(memoryManager, cacheManager));
/* harmony default export */ const src = (DataManager);
/******/ 	return __webpack_exports__;
/******/ })()
;
});